import {createContext} from 'react';

const ReportViewsContext = createContext(null);

export default ReportViewsContext;
